var exports = {
  "zr": "PremiumGiftRedeem.module__root___Mkl4RU",
  "Kk": "PremiumGiftRedeem.module__icon___Mkl4RU",
  "Pf": "PremiumGiftRedeem.module__label___Mkl4RU",
  "hF": "PremiumGiftRedeem.module__input___Mkl4RU",
  "x6": "PremiumGiftRedeem.module__button___Mkl4RU",
};

module.exports = exports;
